export const roundMoney = (value: number | string | null | undefined): number => {
    const amount = Number(value);
    if (Number.isNaN(amount)) {
        return 0;
    }
    return Math.round((amount + Number.EPSILON) * 100) / 100;
};

export const formatMoney = (value: number | string | null | undefined): string => {
    return roundMoney(value).toFixed(2);
};
